module.exports = __webpack_public_path__ + "img/build-an-open-api-with-aws-lambda.450c67b6.jpg";